export const API_SERVER = "https://os.protoenergy.com";
